


import { Component, Vue } from 'vue-property-decorator';

import Assets from '@/constants/assets.ts';
import ExpansionPanel from '@/shared/components/expansion.panel.component.vue';

@Component({
  components: {
    ExpansionPanel,
  },
})
export default class PartialAssets extends Vue {
  private assets = Assets;
}
